'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TeamReporting = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _qs = require('qs');

var _modal = require('./modal');

var _modal2 = _interopRequireDefault(_modal);

var _superagent = require('superagent');

var _superagent2 = _interopRequireDefault(_superagent);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

var _legacyNotification = require('common/components/notifications/legacy-notification');

var _legacyNotification2 = _interopRequireDefault(_legacyNotification);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PropTypes = _react2['default'].PropTypes,
    Component = _react2['default'].Component;

var TeamReporting = exports.TeamReporting = function (_Component) {
    _inherits(TeamReporting, _Component);

    function TeamReporting(props) {
        _classCallCheck(this, TeamReporting);

        var _this = _possibleConstructorReturn(this, (TeamReporting.__proto__ || Object.getPrototypeOf(TeamReporting)).call(this, props));

        _this.handleModalOpen = _this.handleModalOpen.bind(_this);
        _this.handleModalClose = _this.handleModalClose.bind(_this);
        _this.handleSubmit = _this.handleSubmit.bind(_this);
        _this.handleResponse = _this.handleResponse.bind(_this);

        _this.state = {
            modalActive: false,
            busy: false,
            canRequestUsage: props.canRequestUsage
        };
        return _this;
    }

    _createClass(TeamReporting, [{
        key: 'handleError',
        value: function handleError() /* error */{
            this.handleModalClose(function () {
                _legacyNotification2['default'].displayNotification({
                    class_name: 'error',
                    text: 'Sorry, we are unable to process your request at this time. Please try again later',
                    display_time: 10000
                });
            });
        }
    }, {
        key: 'handleModalOpen',
        value: function handleModalOpen() {
            this.setState({ modalActive: true });
        }
    }, {
        key: 'handleModalClose',
        value: function handleModalClose(cb) {
            this.setState({
                modalActive: false,
                busy: false
            }, typeof cb === 'function' && cb());
        }
    }, {
        key: 'handleResponse',
        value: function handleResponse(err, response) {
            if (err) {
                return this.handleError(err);
            }

            // Check for response.success?
            this.handleModalClose(function () {
                _legacyNotification2['default'].displayNotification({
                    class_name: 'success',
                    text: 'Your request is being processed. We will send you an email when the report is ready.',
                    display_time: 10000
                });
            });
        }
    }, {
        key: 'handleSubmit',
        value: function handleSubmit(options) {
            var _this2 = this;

            var csrfToken = this.props.csrfToken;

            var url = _hfReactHelper2['default'].urlHelper('home/requestReport', _hfReactHelper2['default'].HfSites.SITE_CODE_HS);

            var data = (0, _qs.stringify)({
                options: options,
                csrf_token: csrfToken
            });

            this.setState({
                error: undefined,
                successful: false,
                busy: true
            });

            // If requesting usage report, disallow further usage report requests
            if (options['usage'] == true) {
                this.setState({ canRequestUsage: false });
            }

            return _superagent2['default'].post(url).type('form').send(data).on('request', function () {
                return _this2.setState({ busy: true });
            }).end(this.handleResponse);
        }
    }, {
        key: 'render',
        value: function render() {
            var isEnabled = this.props.isEnabled;
            var _state = this.state,
                busy = _state.busy,
                modalActive = _state.modalActive,
                canRequestUsage = _state.canRequestUsage;


            return _react2['default'].createElement(
                'span',
                null,
                _react2['default'].createElement(
                    'a',
                    {
                        className: 'team-page-more-seats',
                        onClick: this.handleModalOpen,
                        style: { padding: '0' }
                    },
                    'DOWNLOAD A REPORT'
                ),
                modalActive && _react2['default'].createElement(_modal2['default'], {
                    busy: busy,
                    allowedOptions: canRequestUsage ? ['usage', 'compliance'] : ['compliance'],
                    isEnabled: isEnabled,
                    onClose: this.handleModalClose,
                    onSubmit: this.handleSubmit
                })
            );
        }
    }]);

    return TeamReporting;
}(Component);

TeamReporting.propTypes = {
    canRequestUsage: PropTypes.bool.isRequired,
    csrfToken: PropTypes.string.isRequired,
    isEnabled: PropTypes.bool.isRequired
};
exports['default'] = TeamReporting;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/team-reporting/index.jsx
 ** module id = 853
 ** module chunks = 0
 **/